/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  /*
   * ==========================================================
   * PARETO / OMEGA SELECTORS
   * ==========================================================
   */

  const WRAPPER_SELECTOR = '.omg-offer-wrapper';

  const CART_NOTICE_SELECTOR = '.omg-quantity-notice';

  /*
   * Full cart applied discount:
   *
   * <li class="line-item__discount">
   */
  const MAIN_CART_DISCOUNT_SELECTOR =
    '.cart-wrapper .line-item__discount';

  /*
   * Warehouse mini-cart applied discount:
   *
   * <li class="mini-cart__discount">
   *
   * This is intentionally DIFFERENT from the full cart.
   */
  const MINI_CART_DISCOUNT_SELECTOR =
    '#mini-cart .mini-cart__discount';

  const TRANSLATABLE_SELECTOR =
    `${WRAPPER_SELECTOR}, ${CART_NOTICE_SELECTOR}, ${MAIN_CART_DISCOUNT_SELECTOR}, ${MINI_CART_DISCOUNT_SELECTOR}`;


  /*
   * ==========================================================
   * PRODUCT PAGE + UPSELL TRANSLATIONS
   * ==========================================================
   *
   * English is the original Pareto text, so it is deliberately
   * not included here.
   *
   * Dynamic values such as:
   *
   * 10
   * 100
   * 700
   * 20 metres
   * 25%
   *
   * are always captured from Pareto's original text and preserved.
   */

  const translations = {

    /*
     * ==========================================================
     * GERMAN
     * ==========================================================
     */

    de: {
      packs: n => `Ab ${n} Packungen`,
      rolls: n => `Ab ${n} Rollen`,
      tools: n => `Ab ${n} Werkzeuge`,
      assortments: n => `Ab ${n} Sortimente`,
      misc: n => `Ab ${n}+`,

      packUnit: n => `pro Packung mit ${n} Stück`,
      packUnitSimple: 'pro Packung',

      rollUnit: n => `pro Rolle à ${n} m`,
      rollUnitSimple: 'pro Rolle',

      toolUnitSimple: 'pro Werkzeug',
      assortmentUnitSimple: 'pro Sortiment',

      each: 'pro Stück',

      bestPrice: 'Bestpreis!',
      packQuantity: 'Packungsmenge',
      boxQuantity: 'Kartonmenge',
      packBestPrice: 'Packungsmenge / Bestpreis!',
      boxBestPrice: 'Kartonmenge / Bestpreis!',

      upsellMore: (q, d) =>
        `Noch ${q} kaufen und ${d} % Rabatt sichern`,

      tierDiscount: (q, d) =>
        `Ab ${q}: ${d} % Rabatt`,

      bestPriceClaimed: d =>
        `Bestpreis erreicht: ${d} % Rabatt!`
    },


    /*
     * ==========================================================
     * DUTCH
     * ==========================================================
     */

    nl: {
      packs: n => `Vanaf ${n} verpakkingen`,
      rolls: n => `Vanaf ${n} rollen`,
      tools: n => `Vanaf ${n} gereedschappen`,
      assortments: n => `Vanaf ${n} assortimenten`,
      misc: n => `Vanaf ${n}+`,

      packUnit: n => `per verpakking van ${n} stuks`,
      packUnitSimple: 'per verpakking',

      rollUnit: n => `per rol van ${n} m`,
      rollUnitSimple: 'per rol',

      toolUnitSimple: 'per gereedschap',
      assortmentUnitSimple: 'per assortiment',

      each: 'per stuk',

      bestPrice: 'Beste prijs!',
      packQuantity: 'Verpakkingsaantal',
      boxQuantity: 'Aantal per doos',
      packBestPrice: 'Verpakkingsaantal / Beste prijs!',
      boxBestPrice: 'Aantal per doos / Beste prijs!',

      upsellMore: (q, d) =>
        `Koop er nog ${q} en krijg ${d}% korting`,

      tierDiscount: (q, d) =>
        `Vanaf ${q}: ${d}% korting`,

      bestPriceClaimed: d =>
        `Beste prijs bereikt: ${d}% korting!`
    },


    /*
     * ==========================================================
     * FRENCH
     * ==========================================================
     */

    fr: {
      packs: n => `Dès ${n} paquets`,
      rolls: n => `Dès ${n} rouleaux`,
      tools: n => `Dès ${n} outils`,
      assortments: n => `Dès ${n} assortiments`,
      misc: n => `Dès ${n}+`,

      packUnit: n => `par paquet de ${n} pièces`,
      packUnitSimple: 'par paquet',

      rollUnit: n => `par rouleau de ${n} m`,
      rollUnitSimple: 'par rouleau',

      toolUnitSimple: 'par outil',
      assortmentUnitSimple: 'par assortiment',

      each: 'l’unité',

      bestPrice: 'Meilleur prix !',
      packQuantity: 'Quantité par paquet',
      boxQuantity: 'Quantité par carton',
      packBestPrice: 'Quantité par paquet / Meilleur prix !',
      boxBestPrice: 'Quantité par carton / Meilleur prix !',

      upsellMore: (q, d) =>
        `Ajoutez-en ${q} pour ${d} % de remise`,

      tierDiscount: (q, d) =>
        `Dès ${q} : ${d} % de remise`,

      bestPriceClaimed: d =>
        `Meilleur prix atteint : ${d} % de remise !`
    },


    /*
     * ==========================================================
     * FINNISH
     * ==========================================================
     */

    fi: {
      packs: n => `Alkaen ${n} pakkauksesta`,
      rolls: n => `Alkaen ${n} rullasta`,
      tools: n => `Alkaen ${n} työkalusta`,
      assortments: n => `Alkaen ${n} lajitelmasta`,
      misc: n => `Alkaen ${n}+`,

      packUnit: n => `pakkausta kohti (${n} kpl)`,
      packUnitSimple: 'pakkausta kohti',

      rollUnit: n => `${n} m:n rullaa kohti`,
      rollUnitSimple: 'rullaa kohti',

      toolUnitSimple: 'työkalua kohti',
      assortmentUnitSimple: 'lajitelmaa kohti',

      each: '/ kpl',

      bestPrice: 'Paras hinta!',
      packQuantity: 'Pakkausmäärä',
      boxQuantity: 'Laatikkomäärä',
      packBestPrice: 'Pakkausmäärä / Paras hinta!',
      boxBestPrice: 'Laatikkomäärä / Paras hinta!',

      upsellMore: (q, d) =>
        `Osta vielä ${q} ja saat ${d} % alennuksen`,

      tierDiscount: (q, d) =>
        `Alkaen ${q}: ${d} % alennus`,

      bestPriceClaimed: d =>
        `Paras hinta saavutettu: ${d} % alennus!`
    },


    /*
     * ==========================================================
     * SWEDISH
     * ==========================================================
     */

    sv: {
      packs: n => `Från ${n} förpackningar`,
      rolls: n => `Från ${n} rullar`,
      tools: n => `Från ${n} verktyg`,
      assortments: n => `Från ${n} sortiment`,
      misc: n => `Från ${n}+`,

      packUnit: n => `per förpackning à ${n} st`,
      packUnitSimple: 'per förpackning',

      rollUnit: n => `per rulle à ${n} m`,
      rollUnitSimple: 'per rulle',

      toolUnitSimple: 'per verktyg',
      assortmentUnitSimple: 'per sortiment',

      each: 'per st.',

      bestPrice: 'Bästa pris!',
      packQuantity: 'Förpackningsantal',
      boxQuantity: 'Kartongantal',
      packBestPrice: 'Förpackningsantal / Bästa pris!',
      boxBestPrice: 'Kartongantal / Bästa pris!',

      upsellMore: (q, d) =>
        `Köp ${q} till och få ${d} % rabatt`,

      tierDiscount: (q, d) =>
        `Från ${q}: ${d} % rabatt`,

      bestPriceClaimed: d =>
        `Bästa priset uppnått: ${d} % rabatt!`
    },


    /*
     * ==========================================================
     * DANISH
     * ==========================================================
     */

    da: {
      packs: n => `Fra ${n} pakker`,
      rolls: n => `Fra ${n} ruller`,
      tools: n => `Fra ${n} værktøjer`,
      assortments: n => `Fra ${n} sortimenter`,
      misc: n => `Fra ${n}+`,

      packUnit: n => `pr. pakke med ${n} stk.`,
      packUnitSimple: 'pr. pakke',

      rollUnit: n => `pr. rulle på ${n} m`,
      rollUnitSimple: 'pr. rulle',

      toolUnitSimple: 'pr. værktøj',
      assortmentUnitSimple: 'pr. sortiment',

      each: 'pr. stk.',

      bestPrice: 'Bedste pris!',
      packQuantity: 'Pakkeantal',
      boxQuantity: 'Kartonantal',
      packBestPrice: 'Pakkeantal / Bedste pris!',
      boxBestPrice: 'Kartonantal / Bedste pris!',

      upsellMore: (q, d) =>
        `Køb ${q} mere og få ${d} % rabat`,

      tierDiscount: (q, d) =>
        `Fra ${q}: ${d} % rabat`,

      bestPriceClaimed: d =>
        `Bedste pris opnået: ${d} % rabat!`
    },


    /*
     * ==========================================================
     * ITALIAN
     * ==========================================================
     */

    it: {
      packs: n => `Da ${n} confezioni`,
      rolls: n => `Da ${n} rotoli`,
      tools: n => `Da ${n} utensili`,
      assortments: n => `Da ${n} assortimenti`,
      misc: n => `Da ${n}+`,

      packUnit: n => `per confezione da ${n} pezzi`,
      packUnitSimple: 'per confezione',

      rollUnit: n => `per rotolo da ${n} m`,
      rollUnitSimple: 'per rotolo',

      toolUnitSimple: 'per utensile',
      assortmentUnitSimple: 'per assortimento',

      each: 'cad.',

      bestPrice: 'Miglior prezzo!',
      packQuantity: 'Quantità confezione',
      boxQuantity: 'Quantità per cartone',
      packBestPrice: 'Quantità confezione / Miglior prezzo!',
      boxBestPrice: 'Quantità per cartone / Miglior prezzo!',

      upsellMore: (q, d) =>
        `Aggiungine ${q} e ottieni il ${d}% di sconto`,

      tierDiscount: (q, d) =>
        `Da ${q}: ${d}% di sconto`,

      bestPriceClaimed: d =>
        `Miglior prezzo raggiunto: ${d}% di sconto!`
    },


    /*
     * ==========================================================
     * SPANISH
     * ==========================================================
     */

    es: {
      packs: n => `Desde ${n} paquetes`,
      rolls: n => `Desde ${n} rollos`,
      tools: n => `Desde ${n} herramientas`,
      assortments: n => `Desde ${n} surtidos`,
      misc: n => `Desde ${n}+`,

      packUnit: n => `por paquete de ${n} uds.`,
      packUnitSimple: 'por paquete',

      rollUnit: n => `por rollo de ${n} m`,
      rollUnitSimple: 'por rollo',

      toolUnitSimple: 'por herramienta',
      assortmentUnitSimple: 'por surtido',

      each: 'por unidad',

      bestPrice: '¡Mejor precio!',
      packQuantity: 'Cantidad por paquete',
      boxQuantity: 'Cantidad por caja',
      packBestPrice: 'Cantidad por paquete / ¡Mejor precio!',
      boxBestPrice: 'Cantidad por caja / ¡Mejor precio!',

      upsellMore: (q, d) =>
        `Compra ${q} más y consigue un ${d} % de descuento`,

      tierDiscount: (q, d) =>
        `Desde ${q}: ${d} % de descuento`,

      bestPriceClaimed: d =>
        `¡Mejor precio alcanzado: ${d} % de descuento!`
    },


    /*
     * ==========================================================
     * CZECH
     * ==========================================================
     */

    cs: {
      packs: n => `Od ${n} balení`,
      rolls: n => `Od ${n} rolí`,
      tools: n => `Od ${n} nástrojů`,
      assortments: n => `Od ${n} sad`,
      misc: n => `Od ${n}+`,

      packUnit: n => `za balení po ${n} ks`,
      packUnitSimple: 'za balení',

      rollUnit: n => `za roli ${n} m`,
      rollUnitSimple: 'za roli',

      toolUnitSimple: 'za nástroj',
      assortmentUnitSimple: 'za sadu',

      each: 'za kus',

      bestPrice: 'Nejlepší cena!',
      packQuantity: 'Množství v balení',
      boxQuantity: 'Množství v kartonu',
      packBestPrice: 'Množství v balení / Nejlepší cena!',
      boxBestPrice: 'Množství v kartonu / Nejlepší cena!',

      upsellMore: (q, d) =>
        `Kupte ještě ${q} a získejte slevu ${d} %`,

      tierDiscount: (q, d) =>
        `Od ${q}: sleva ${d} %`,

      bestPriceClaimed: d =>
        `Nejlepší cena dosažena: sleva ${d} %!`
    },


    /*
     * ==========================================================
     * POLISH
     * ==========================================================
     */

    pl: {
      packs: n => `Od ${n} opakowań`,
      rolls: n => `Od ${n} rolek`,
      tools: n => `Od ${n} narzędzi`,
      assortments: n => `Od ${n} zestawów`,
      misc: n => `Od ${n}+`,

      packUnit: n => `za opakowanie ${n} szt.`,
      packUnitSimple: 'za opakowanie',

      rollUnit: n => `za rolkę ${n} m`,
      rollUnitSimple: 'za rolkę',

      toolUnitSimple: 'za narzędzie',
      assortmentUnitSimple: 'za zestaw',

      each: 'za szt.',

      bestPrice: 'Najlepsza cena!',
      packQuantity: 'Ilość w opakowaniu',
      boxQuantity: 'Ilość w kartonie',
      packBestPrice: 'Ilość w opakowaniu / Najlepsza cena!',
      boxBestPrice: 'Ilość w kartonie / Najlepsza cena!',

      upsellMore: (q, d) =>
        `Kup jeszcze ${q} i zyskaj ${d}% rabatu`,

      tierDiscount: (q, d) =>
        `Od ${q}: ${d}% rabatu`,

      bestPriceClaimed: d =>
        `Najlepsza cena uzyskana: ${d}% rabatu!`
    }
  };


  /*
   * ==========================================================
   * APPLIED DISCOUNT LABELS
   * ==========================================================
   *
   * These are handled separately because the full cart has
   * plenty of room, while Warehouse's mini-cart is deliberately
   * narrow.
   *
   * Example German:
   *
   * FULL CART:
   * Mengenrabatt (-176,00 €)
   *
   * MINI-CART:
   * Rabatt (-176,00 €)
   *
   * The dynamic monetary value itself is NEVER rewritten.
   */

  const appliedDiscountLabels = {
    en: {
      main: 'Volume Discount',
      mini: 'Discount'
    },

    de: {
      main: 'Mengenrabatt',
      mini: 'Rabatt'
    },

    nl: {
      main: 'Volumekorting',
      mini: 'Korting'
    },

    fr: {
      main: 'Remise sur quantité',
      mini: 'Remise'
    },

    fi: {
      main: 'Määräalennus',
      mini: 'Alennus'
    },

    sv: {
      main: 'Volymrabatt',
      mini: 'Rabatt'
    },

    da: {
      main: 'Mængderabat',
      mini: 'Rabat'
    },

    it: {
      main: 'Sconto quantità',
      mini: 'Sconto'
    },

    es: {
      main: 'Descuento por volumen',
      mini: 'Descuento'
    },

    cs: {
      main: 'Množstevní sleva',
      mini: 'Sleva'
    },

    pl: {
      main: 'Rabat ilościowy',
      mini: 'Rabat'
    }
  };


  /*
   * ==========================================================
   * GET CURRENT STOREFRONT LANGUAGE
   * ==========================================================
   */

  function getLocale() {
    const rawLocale =
      (window.LangShopConfig &&
        window.LangShopConfig.currentLanguage) ||
      (window.Shopify &&
        window.Shopify.locale) ||
      document.documentElement.lang ||
      'en';

    return String(rawLocale)
      .toLowerCase()
      .split(/[-_]/)[0];
  }


  /*
   * ==========================================================
   * TRANSLATE INDIVIDUAL TEXT
   * ==========================================================
   */

  function translateCore(core, t) {
    let match;


    /*
     * ==========================================================
     * VOLUME BREAK TITLES - PACKS
     * ==========================================================
     */

    match = core.match(
      /^Buy\s+(\d+)\s*\+\s+packs$/i
    );

    if (match) {
      return t.packs(match[1]);
    }


    /*
     * ==========================================================
     * VOLUME BREAK TITLES - ROLLS
     * ==========================================================
     */

    match = core.match(
      /^Buy\s+(\d+)\s*\+\s+rolls$/i
    );

    if (match) {
      return t.rolls(match[1]);
    }


    /*
     * ==========================================================
     * VOLUME BREAK TITLES - TOOLS
     * ==========================================================
     *
     * Example:
     *
     * Buy 5+ tools
     */

    match = core.match(
      /^Buy\s+(\d+)\s*\+\s+tools$/i
    );

    if (match) {
      return t.tools(match[1]);
    }


    /*
     * ==========================================================
     * VOLUME BREAK TITLES - ASSORTMENTS
     * ==========================================================
     *
     * Example:
     *
     * Buy 5+ assortments
     */

    match = core.match(
      /^Buy\s+(\d+)\s*\+\s+assortments$/i
    );

    if (match) {
      return t.assortments(match[1]);
    }


    /*
     * ==========================================================
     * MISCELLANEOUS VOLUME BREAK TITLES
     * ==========================================================
     */

    match = core.match(
      /^Buy\s+(\d+)\s*\+$/i
    );

    if (match) {
      return t.misc(match[1]);
    }


    /*
     * ==========================================================
     * PRICE PER PACK WITH QUANTITY
     * ==========================================================
     */

    match = core.match(
      /^per\s+pack\s+of\s+([\d.,]+)$/i
    );

    if (match) {
      return t.packUnit(match[1]);
    }


    /*
     * ==========================================================
     * PRICE PER PACK
     * ==========================================================
     */

    if (/^per\s+pack$/i.test(core)) {
      return t.packUnitSimple;
    }


    /*
     * ==========================================================
     * PRICE PER ROLL WITH LENGTH
     * ==========================================================
     *
     * Examples:
     *
     * per 20 metre roll
     * per 45 metre roll
     * per 50 metre roll
     * per 500 metre roll
     */

    match = core.match(
      /^per\s+([\d.,]+)\s+met(?:re|er)s?\s+roll$/i
    );

    if (match) {
      return t.rollUnit(match[1]);
    }


    /*
     * Defensive alternative:
     *
     * per roll of 20 metres
     */

    match = core.match(
      /^per\s+roll\s+of\s+([\d.,]+)\s+met(?:re|er)s?$/i
    );

    if (match) {
      return t.rollUnit(match[1]);
    }


    /*
     * ==========================================================
     * PRICE PER ROLL
     * ==========================================================
     */

    if (/^per\s+roll$/i.test(core)) {
      return t.rollUnitSimple;
    }


    /*
     * ==========================================================
     * PRICE PER TOOL
     * ==========================================================
     */

    if (/^per\s+tool$/i.test(core)) {
      return t.toolUnitSimple;
    }


    /*
     * ==========================================================
     * PRICE PER ASSORTMENT
     * ==========================================================
     */

    if (/^per\s+assortment$/i.test(core)) {
      return t.assortmentUnitSimple;
    }


    /*
     * ==========================================================
     * SINGLE ITEM PRICE
     * ==========================================================
     */

    if (/^each$/i.test(core)) {
      return t.each;
    }


    /*
     * ==========================================================
     * CART UPSELL
     * ==========================================================
     *
     * Example:
     *
     * Buy 1 more to get 25% off
     *
     * Both numbers remain dynamic.
     */

    match = core.match(
      /^Buy\s+([\d.,]+)\s+more\s+to\s+get\s+([\d.,]+)\s*%\s+off!?$/i
    );

    if (match) {
      return t.upsellMore(
        match[1],
        match[2]
      );
    }


    /*
     * ==========================================================
     * DEFENSIVE CART UPSELL FORMAT
     * ==========================================================
     *
     * Example:
     *
     * You're 5 away from 10% off discount
     */

    match = core.match(
      /^You(?:'|’)?re\s+([\d.,]+)\s+away\s+from\s+([\d.,]+)\s*%\s+off(?:\s+discount)?!?$/i
    );

    if (match) {
      return t.upsellMore(
        match[1],
        match[2]
      );
    }


    /*
     * ==========================================================
     * ALTERNATIVE PARETO FORMAT
     * ==========================================================
     *
     * Example:
     *
     * Buy 30 + discount 20%
     */

    match = core.match(
      /^Buy\s+([\d.,]+)\s*\+\s*discount\s+([\d.,]+)\s*%!?$/i
    );

    if (match) {
      return t.tierDiscount(
        match[1],
        match[2]
      );
    }


    /*
     * ==========================================================
     * BEST PRICE CLAIMED
     * ==========================================================
     *
     * Example:
     *
     * Best price claimed: 43% off!
     */

    match = core.match(
      /^Best\s+price\s+claimed:\s*([\d.,]+)\s*%\s+off!?$/i
    );

    if (match) {
      return t.bestPriceClaimed(
        match[1]
      );
    }


    /*
     * ==========================================================
     * BLUE QUANTITY / BEST PRICE BADGES
     * ==========================================================
     */

    const badgeKey = core
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

    if (badgeKey === 'best price!') {
      return t.bestPrice;
    }

    if (badgeKey === 'pack quantity') {
      return t.packQuantity;
    }

    if (badgeKey === 'box quantity') {
      return t.boxQuantity;
    }

    if (
      badgeKey ===
      'pack quantity / best price!'
    ) {
      return t.packBestPrice;
    }

    if (
      badgeKey ===
      'box quantity / best price!'
    ) {
      return t.boxBestPrice;
    }

    return core;
  }


  /*
   * ==========================================================
   * TRANSLATE TEXT NODE
   * ==========================================================
   */

  function translateTextNode(node, t) {
    const original = node.nodeValue;

    if (!original || !original.trim()) {
      return;
    }

    const leading =
      original.match(/^\s*/)[0];

    const trailing =
      original.match(/\s*$/)[0];

    const core =
      original.slice(
        leading.length,
        original.length -
          trailing.length
      );

    const translated =
      translateCore(
        core,
        t
      );

    if (translated !== core) {
      node.nodeValue =
        leading +
        translated +
        trailing;
    }
  }


  /*
   * ==========================================================
   * TRANSLATE ALL TEXT INSIDE A PARETO ELEMENT
   * ==========================================================
   */

  function translateWrapper(wrapper, t) {
    const walker =
      document.createTreeWalker(
        wrapper,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            const parent =
              node.parentElement;

            if (!parent) {
              return NodeFilter
                .FILTER_REJECT;
            }

            if (
              parent.closest(
                'script, style, noscript, textarea'
              )
            ) {
              return NodeFilter
                .FILTER_REJECT;
            }

            return NodeFilter
              .FILTER_ACCEPT;
          }
        }
      );

    let node;

    while (
      (node =
        walker.nextNode())
    ) {
      translateTextNode(
        node,
        t
      );
    }
  }


  /*
   * ==========================================================
   * APPLIED DISCOUNT LABEL
   * ==========================================================
   *
   * Warehouse generates:
   *
   * <svg>...</svg>
   * Volume Discount (-
   * <span class="dualPrice">
   *   <span class="finalPrice">58,05 €</span>
   * </span>
   * )
   *
   * We alter ONLY the text before .dualPrice.
   *
   * The price element itself remains completely untouched,
   * which means currency changes and Pareto discount updates
   * continue working normally.
   */

  function setAppliedDiscountLabel(
    discount,
    label
  ) {
    if (!discount || !label) {
      return;
    }

    /*
     * Pareto's dynamic money wrapper.
     */

    const priceWrapper =
      discount.querySelector(
        '.dualPrice'
      );

if (!priceWrapper) {
  // Fallback for currencies such as SEK where Pareto
  // renders the discount without a .dualPrice wrapper.
  // Replace only the label, preserving the amount.

  Array.from(discount.childNodes)
    .filter(node => node.nodeType === Node.TEXT_NODE)
    .some(node => {
      const original = node.nodeValue || '';
      const updated = original.replace(
        /Volume Discount/i,
        label
      );

      if (updated !== original) {
        node.nodeValue = updated;
        return true;
      }

      return false;
    });

  return;
}


    /*
     * In both Warehouse cart structures the
     * .dualPrice element is a direct child of
     * the discount <li>.
     */

    const children =
      Array.from(
        discount.childNodes
      );

    const priceIndex =
      children.indexOf(
        priceWrapper
      );

    if (priceIndex === -1) {
      return;
    }


    /*
     * Find the nearest non-empty text node
     * immediately before the dynamic price.
     *
     * This means it does not matter whether
     * the text currently says:
     *
     * Volume Discount
     * Mengenrabatt
     * Volumekorting
     * Remise sur quantité
     *
     * etc.
     */

    let labelNode = null;

    for (
      let i =
        priceIndex - 1;
      i >= 0;
      i--
    ) {
      const node =
        children[i];

      if (
        node.nodeType ===
          Node.TEXT_NODE &&
        node.nodeValue &&
        node.nodeValue.trim()
      ) {
        labelNode = node;
        break;
      }
    }

    if (!labelNode) {
      return;
    }


    /*
     * Preserve any existing leading whitespace,
     * but replace the actual label.
     */

    const original =
      labelNode.nodeValue || '';

    const leading =
      original.match(/^\s*/)[0];

    const replacement =
      `${leading}${label} (-`;

    if (
      labelNode.nodeValue !==
      replacement
    ) {
      labelNode.nodeValue =
        replacement;
    }
  }


  /*
   * ==========================================================
   * TRANSLATE FULL CART APPLIED DISCOUNTS
   * ==========================================================
   */

  function translateMainCartDiscounts(
    labels
  ) {
    if (
      !labels ||
      !labels.main
    ) {
      return;
    }

    document
      .querySelectorAll(
        MAIN_CART_DISCOUNT_SELECTOR
      )
      .forEach(discount => {
        setAppliedDiscountLabel(
          discount,
          labels.main
        );
      });
  }


  /*
   * ==========================================================
   * TRANSLATE MINI-CART APPLIED DISCOUNTS
   * ==========================================================
   *
   * IMPORTANT:
   *
   * Warehouse uses:
   *
   * .mini-cart__discount
   *
   * NOT:
   *
   * .line-item__discount
   *
   * This is why the previous mini-cart shortening
   * attempt did not fire.
   */

  function translateMiniCartDiscounts(
    labels
  ) {
    if (
      !labels ||
      !labels.mini
    ) {
      return;
    }

    document
      .querySelectorAll(
        MINI_CART_DISCOUNT_SELECTOR
      )
      .forEach(discount => {
        setAppliedDiscountLabel(
          discount,
          labels.mini
        );
      });
  }


  /*
   * ==========================================================
   * TRANSLATE EVERYTHING CURRENTLY ON THE PAGE
   * ==========================================================
   */

  function translateAll() {
    const locale =
      getLocale();

    const t =
      translations[locale];

    const labels =
      appliedDiscountLabels[locale] ||
      appliedDiscountLabels.en;


    /*
     * Product-page cards and orange upsells.
     *
     * English stays as Pareto originally generates it.
     */

    if (t) {

      /*
       * PRODUCT PAGE VOLUME DISCOUNT CARDS
       */

      document
        .querySelectorAll(
          WRAPPER_SELECTOR
        )
        .forEach(wrapper => {
          translateWrapper(
            wrapper,
            t
          );
        });


      /*
       * CART + MINI-CART ORANGE UPSELL NOTICES
       *
       * Examples:
       *
       * Buy 1 more to get 25% off
       * Best price claimed: 43% off!
       */

      document
        .querySelectorAll(
          CART_NOTICE_SELECTOR
        )
        .forEach(notice => {
          translateWrapper(
            notice,
            t
          );
        });
    }


    /*
     * APPLIED DISCOUNT LABELS
     *
     * These run for English too because the
     * English mini-cart uses the compact
     * "Discount" wording.
     */

    translateMainCartDiscounts(
      labels
    );

    translateMiniCartDiscounts(
      labels
    );
  }


  /*
   * ==========================================================
   * MUTATION HANDLING
   * ==========================================================
   *
   * Pareto and Warehouse dynamically rebuild parts of:
   *
   * - product discount cards
   * - cart upsell messages
   * - mini-cart items
   * - applied discount amounts
   *
   * Therefore translations must be reapplied whenever
   * one of those relevant areas changes.
   */

  let translationScheduled = false;


  function scheduleTranslation() {
    if (translationScheduled) {
      return;
    }

    translationScheduled = true;

    requestAnimationFrame(() => {
      translationScheduled = false;

      translateAll();
    });
  }


  function mutationTouchesRelevantArea(
    mutation
  ) {

    /*
     * Existing text changed.
     */

    if (
      mutation.type ===
      'characterData'
    ) {
      const parent =
        mutation.target
          .parentElement;

      return !!(
        parent &&
        parent.closest(
          TRANSLATABLE_SELECTOR
        )
      );
    }


    /*
     * New/replacement elements inserted.
     */

    if (
      mutation.type ===
      'childList'
    ) {

      if (
        mutation.target
          instanceof Element &&
        mutation.target.closest(
          TRANSLATABLE_SELECTOR
        )
      ) {
        return true;
      }


      return Array
        .from(
          mutation.addedNodes
        )
        .some(node => {

          if (
            !(node instanceof Element)
          ) {
            return false;
          }

          return (
            node.matches(
              TRANSLATABLE_SELECTOR
            ) ||
            node.querySelector(
              TRANSLATABLE_SELECTOR
            ) !== null
          );
        });
    }

    return false;
  }


  /*
   * ==========================================================
   * INITIALISE
   * ==========================================================
   */

  function initialiseVolumeTranslations() {

    /*
     * Run once against the HTML already
     * present when the page loads.
     *
     * This is particularly useful for the
     * Warehouse mini-cart because its items
     * already exist inside #mini-cart even
     * while the mini-cart is closed.
     */

    translateAll();


    /*
     * Watch subsequent Pareto / Warehouse
     * DOM changes.
     */

    const observer =
      new MutationObserver(
        mutations => {

          if (
            mutations.some(
              mutationTouchesRelevantArea
            )
          ) {
            scheduleTranslation();
          }
        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );


    /*
     * Warehouse-specific cart events.
     *
     * These provide additional fallbacks
     * whenever the cart is refreshed.
     */

    document.addEventListener(
      'product:added',
      scheduleTranslation
    );

    document.addEventListener(
      'cart:refresh',
      scheduleTranslation
    );

    document.addEventListener(
      'variant:changed',
      scheduleTranslation
    );
  }


  /*
   * ==========================================================
   * YOTPO REVIEW WIDGET TRANSLATION FIX
   * ==========================================================
   */
(function () {
  /*
   * Yotpo review count localisation fix for KAB
   *
   * Fixes:
   * - Incorrect singular/plural review-count wording
   * - Polish/Czech multi-form pluralisation
   * - Incorrect Yotpo aria-label pluralisation
   * - Incorrect review-count sentence in the main/lower Reviews widget
   * - Sensible accessibility wording for products with 0 reviews
   * - Locale-correct rating decimal separators
   * - Yotpo/LangShop asynchronous rerendering
   */

  const LANGUAGES = {
    en: {
      forms: {
        one: 'Review',
        other: 'Reviews'
      },

      // Yotpo already gets the visible English text right.
      fixVisible: false,

      aria: function (rating, countText) {
        return rating + ' out of 5 stars. ' +
          countText + '. Jump to reviews.';
      },

      ariaZero: 'No reviews yet. Jump to reviews.'
    },

    de: {
      forms: {
        one: 'Bewertung',
        other: 'Bewertungen'
      },

      aria: function (rating, countText) {
        return rating + ' von 5 Sternen. ' +
          countText + '. Zu den Bewertungen springen.';
      },

      ariaZero: 'Noch keine Bewertungen. Zu den Bewertungen springen.'
    },

    nl: {
      forms: {
        one: 'recensie',
        other: 'recensies'
      },

      aria: function (rating, countText) {
        return rating + ' van 5 sterren. ' +
          countText + '. Ga naar de recensies.';
      },

      ariaZero: 'Nog geen recensies. Ga naar de recensies.'
    },

    sv: {
      forms: {
        one: 'omdöme',
        other: 'omdömen'
      },

      aria: function (rating, countText) {
        return rating + ' av 5 stjärnor. ' +
          countText + '. Gå till omdömena.';
      },

      ariaZero: 'Inga omdömen ännu. Gå till omdömena.'
    },

    fi: {
      forms: {
        one: 'arvostelu',
        other: 'arvostelua'
      },

      aria: function (rating, countText) {
        return 'Arvosana ' + rating + '/5. ' +
          countText + '. Siirry arvosteluihin.';
      },

      ariaZero: 'Ei vielä arvosteluja. Siirry arvosteluihin.'
    },

    fr: {
      forms: {
        one: 'avis',
        other: 'avis'
      },

      // "avis" is the same in singular and plural,
      // so Yotpo's visible text doesn't need changing.
      fixVisible: false,

      aria: function (rating, countText) {
        return 'Note : ' + rating + ' sur 5. ' +
          countText + '. Aller aux avis.';
      },

      ariaZero: 'Aucun avis. Aller aux avis.'
    },

    es: {
      forms: {
        one: 'reseña',
        other: 'reseñas'
      },

      aria: function (rating, countText) {
        return 'Valoración: ' + rating + ' de 5 estrellas. ' +
          countText + '. Ir a las reseñas.';
      },

      ariaZero: 'Aún no hay reseñas. Ir a las reseñas.'
    },

    da: {
      forms: {
        one: 'anmeldelse',
        other: 'anmeldelser'
      },

      aria: function (rating, countText) {
        return 'Bedømmelse: ' + rating + ' ud af 5 stjerner. ' +
          countText + '. Gå til anmeldelserne.';
      },

      ariaZero: 'Ingen anmeldelser endnu. Gå til anmeldelserne.'
    },

    it: {
      forms: {
        one: 'recensione',
        other: 'recensioni'
      },

      aria: function (rating, countText) {
        return 'Valutazione: ' + rating + ' su 5 stelle. ' +
          countText + '. Vai alle recensioni.';
      },

      ariaZero: 'Nessuna recensione. Vai alle recensioni.'
    },

    pl: {
      forms: {
        one: 'ocena',
        few: 'oceny',
        many: 'ocen',
        other: 'ocen'
      },

      aria: function (rating, countText) {
        return 'Ocena: ' + rating + ' na 5. ' +
          countText + '. Przejdź do recenzji.';
      },

      ariaZero: 'Brak ocen. Przejdź do recenzji.'
    },

    cs: {
      forms: {
        one: 'recenze',
        few: 'recenze',
        many: 'recenze',
        other: 'recenzí'
      },

      aria: function (rating, countText) {
        return 'Hodnocení ' + rating + ' z 5. ' +
          countText + '. Přejít k recenzím.';
      },

      ariaZero: 'Zatím žádné recenze. Přejít k recenzím.'
    }
  };


  /*
   * Yotpo elements
   */

  const TEXT_SELECTOR =
    '.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel';

  const BUTTON_SELECTOR =
    '.yotpo-sr-bottom-line-summary.yotpo-sr-bottom-line-button';

  const MAIN_SUMMARY_SELECTOR =
    '.yotpo-main-reviews-widget .yotpo-bottom-line-basic-text';


  /*
   * Get current Shopify storefront language.
   *
   * Examples:
   * en
   * de
   * fi
   * pl
   * en-GB -> en
   */
  function getLanguage() {
    return (document.documentElement.lang || '')
      .toLowerCase()
      .split('-')[0];
  }


  /*
   * Extract review count from Yotpo's visible text.
   *
   * Examples:
   * "0 Oceny"         -> 0
   * "1 Bewertungen"  -> 1
   * "86 Reviews"      -> 86
   */
  function getCount(element) {
    if (!element) return null;

    const text = element.textContent.trim();
    const match = text.match(/^(\d+)/);

    if (!match) return null;

    return parseInt(match[1], 10);
  }


  /*
   * Extract a review count when the number appears anywhere
   * inside a sentence in the main/lower Reviews widget.
   *
   * Example:
   * "Basierend auf 1 Bewertungen" -> 1
   */
  function getCountAnywhere(element) {
    if (!element) return null;

    const text = element.textContent.trim();
    const match = text.match(/(\d+)/);

    if (!match) return null;

    return parseInt(match[1], 10);
  }


  /*
   * Ask the browser for the correct plural category.
   *
   * This is particularly important for languages such as:
   *
   * Polish:
   * 1 ocena
   * 2 oceny
   * 5 ocen
   * 22 oceny
   * 25 ocen
   *
   * Czech:
   * 1 recenze
   * 2 recenze
   * 5 recenzí
   */
  function getCorrectCountText(language, count) {
    const config = LANGUAGES[language];

    if (!config) return null;

    let pluralRules;

    try {
      pluralRules = new Intl.PluralRules(language);
    } catch (error) {
      return null;
    }

    const category = pluralRules.select(count);

    const reviewWord =
      config.forms[category] ||
      config.forms.other;

    if (!reviewWord) return null;

    return count + ' ' + reviewWord;
  }


  /*
   * Build the count sentence used by Yotpo's main/lower
   * Reviews widget.
   *
   * This cannot always reuse the short review-count label
   * because the surrounding sentence can require a different
   * grammatical case in languages such as Finnish, Polish
   * and Czech.
   */
  function getMainReviewSummary(language, count) {
    const countText =
      getCorrectCountText(language, count);

    switch (language) {
      case 'en':
        return countText
          ? 'Based on ' + countText
          : null;

      case 'de':
        return countText
          ? 'Basierend auf ' + countText
          : null;

      case 'nl':
        return countText
          ? 'Gebaseerd op ' + countText
          : null;

      case 'sv':
        return countText
          ? 'Baserat på ' + countText
          : null;

      case 'fi':
        return 'Perustuu ' + count + ' arvosteluun';

      case 'fr':
        return 'Basé sur ' + count + ' avis';

      case 'es':
        return countText
          ? 'Basado en ' + countText
          : null;

      case 'da':
        return countText
          ? 'Baseret på ' + countText
          : null;

      case 'it':
        return countText
          ? 'Basato su ' + countText
          : null;

      case 'pl':
        return 'Na podstawie ' + count + ' ' +
          (count === 1 ? 'oceny' : 'ocen');

      case 'cs':
        return 'Na základě ' + count + ' ' +
          (count === 1 ? 'recenze' : 'recenzí');

      default:
        return null;
    }
  }


  /*
   * Extract Yotpo's actual star rating from its aria-label.
   *
   * Examples:
   *
   * "4.9 out of 5 stars..."
   * -> 4.9
   *
   * "4,9 von 5 Sternen..."
   * -> 4,9
   *
   * Yotpo's numeric rating is converted to a real number and
   * then reformatted using the active storefront locale.
   */
  function getRating(button, language) {
    if (!button) return null;

    const aria = button.getAttribute('aria-label') || '';

    const match = aria.match(/(\d+(?:[.,]\d+)?)/);

    if (!match) return null;

    /*
     * Convert Yotpo's rating to a real number first.
     *
     * Examples:
     * 4.9 -> 4.9
     * 4,9 -> 4.9
     */
    const numericRating =
      Number(match[1].replace(',', '.'));

    if (!Number.isFinite(numericRating)) {
      return match[1];
    }

    /*
     * Format the rating using the active storefront locale.
     *
     * Examples:
     * en -> 4.9
     * de -> 4,9
     * fi -> 4,9
     * nl -> 4,9
     * fr -> 4,9
     */
    try {
      return new Intl.NumberFormat(language, {
        maximumFractionDigits: 2
      }).format(numericRating);
    } catch (error) {
      return match[1];
    }
  }


  /*
   * Correct the visible review-count text.
   */
  function fixVisibleReviewCounts(language) {
    const config = LANGUAGES[language];

    if (!config) return;

    // English and French visible text already works correctly.
    if (config.fixVisible === false) return;

    document.querySelectorAll(TEXT_SELECTOR).forEach(function (element) {
      const count = getCount(element);

      if (count === null) return;

      const correctedText =
        getCorrectCountText(language, count);

      if (!correctedText) return;

      if (element.textContent.trim() !== correctedText) {
        element.textContent = correctedText;
      }
    });
  }



  /*
   * Correct the count sentence in Yotpo's main/lower
   * Reviews widget.
   *
   * Example German:
   * "Basierend auf 1 Bewertungen"
   * becomes
   * "Basierend auf 1 Bewertung"
   */
  function fixMainReviewSummary(language) {
    document
      .querySelectorAll(MAIN_SUMMARY_SELECTOR)
      .forEach(function (element) {
        const count = getCountAnywhere(element);

        if (count === null) return;

        const correctedText =
          getMainReviewSummary(language, count);

        if (!correctedText) return;

        if (element.textContent.trim() !== correctedText) {
          element.textContent = correctedText;
        }
      });
  }


  /*
   * Correct the accessibility aria-label.
   */
  function fixAriaLabels(language) {
    const config = LANGUAGES[language];

    if (!config) return;

    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      const textElement =
        button.querySelector(TEXT_SELECTOR);

      if (!textElement) return;

      const count = getCount(textElement);

      if (count === null) return;


      /*
       * ZERO REVIEWS
       *
       * A product with no reviews does not really have
       * a "0 out of 5 star rating".
       *
       * Instead announce that there are no reviews yet.
       */
      if (count === 0) {
        const correctedAria = config.ariaZero;

        if (
          correctedAria &&
          button.getAttribute('aria-label') !== correctedAria
        ) {
          button.setAttribute('aria-label', correctedAria);
        }

        return;
      }


      /*
       * ONE OR MORE REVIEWS
       */
      const countText =
        getCorrectCountText(language, count);

      if (!countText) return;

      const rating = getRating(button, language);

      if (!rating) return;

      const correctedAria =
        config.aria(rating, countText);

      if (
        correctedAria &&
        button.getAttribute('aria-label') !== correctedAria
      ) {
        button.setAttribute('aria-label', correctedAria);
      }
    });
  }


  /*
   * Apply all Yotpo localisation corrections.
   */
  function fixYotpoTranslations() {
    const language = getLanguage();

    if (!LANGUAGES[language]) return;

    fixVisibleReviewCounts(language);
    fixMainReviewSummary(language);
    fixAriaLabels(language);
  }


  /*
   * Run immediately.
   *
   * This catches Yotpo if the widget has already rendered
   * before this script executes.
   */
  fixYotpoTranslations();


  /*
   * Yotpo and/or translation scripts can subsequently:
   *
   * - Insert the widget
   * - Replace its text
   * - Change text nodes
   * - Rewrite aria-label
   *
   * Watch all of those cases and reapply our correction.
   *
   * requestAnimationFrame prevents us from running the
   * correction repeatedly during a burst of DOM mutations.
   */
  let scheduled = false;

  const observer = new MutationObserver(function () {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      fixYotpoTranslations();
    });
  });


  /*
   * Start observing once BODY exists.
   */
  function startObserver() {
    if (!document.body) {
      document.addEventListener(
        'DOMContentLoaded',
        startObserver,
        { once: true }
      );

      return;
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true,

      // Catch Yotpo/LangShop changing an existing text node.
      characterData: true,

      // Catch Yotpo replacing our corrected aria-label.
      attributes: true,
      attributeFilter: ['aria-label']
    });

    // One more pass now that BODY definitely exists.
    fixYotpoTranslations();
  }


  startObserver();
})();


  /*
   * Initialise the existing Pareto / Omega translation system.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseVolumeTranslations,
      { once: true }
    );
  } else {
    initialiseVolumeTranslations();
  }

})();
/*
 * ------------------------------------------------------------
 * Chatty AI Mode - Default to "Ask Kabelbinders AI"
 * ------------------------------------------------------------
 *
 * Chatty's AI Mode currently opens with the Search tab selected.
 * This waits for Chatty to render and switches to the Ask/AI tab
 * using Chatty's own button click behaviour.
 *
 * It does NOT disable Search. Customers can still manually switch
 * to the Search tab afterwards.
 * ------------------------------------------------------------
 */

(function () {
  'use strict';

  const ASK_SELECTOR = 'button.aimode-seg-btn[data-seg="ask"]';

  let hasSelectedAsk = false;

  function selectAskMode() {
    if (hasSelectedAsk) {
      return;
    }

    const askButton = document.querySelector(ASK_SELECTOR);

    if (!askButton) {
      return;
    }

    const isAlreadySelected =
      askButton.getAttribute('aria-selected') === 'true' ||
      askButton.classList.contains('is-on');

    if (!isAlreadySelected) {
      askButton.click();
    }

    hasSelectedAsk = true;
  }

  // Try immediately in case Chatty has already rendered.
  selectAskMode();

  // Chatty is loaded asynchronously, so watch for its UI to appear.
  const observer = new MutationObserver(function () {
    selectAskMode();

    if (hasSelectedAsk) {
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Safety fallback so the observer does not live forever.
  window.setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();